class NLDescriptionTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.downloadReady === 'true') return;

    const downloadLinks = Array.from(this.querySelectorAll('.accordion__content a')).filter((link) =>
      this.isDownloadLink(link)
    );

    this.dataset.downloadReady = 'true';
    if (downloadLinks.length === 0) return;

    const downloadsAccordion = document.createElement('div');
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const summaryTitle = document.createElement('span');
    const accordionTitle = document.createElement('span');
    const content = document.createElement('div');

    downloadsAccordion.className = 'product__accordion accordion nl-product-downloads';
    summaryTitle.className = 'summary__title';
    accordionTitle.className = 'accordion__title';
    accordionTitle.textContent = 'DESCARGABLES';
    content.className = 'accordion__content rte nl-product-downloads__content';

    summaryTitle.appendChild(accordionTitle);
    summary.appendChild(summaryTitle);

    const existingCaret = this.querySelector('summary .icon-caret');
    if (existingCaret) summary.appendChild(existingCaret.cloneNode(true));

    downloadLinks.forEach((link) => {
      const originalParent = link.parentElement;
      link.classList.add('nl-product-downloads__link');
      content.appendChild(link);
      this.removeEmptyWrapper(originalParent);
    });

    details.append(summary, content);
    downloadsAccordion.appendChild(details);
    this.appendChild(downloadsAccordion);
  }

  isDownloadLink(link) {
    const label = this.normalizeText(link.textContent);
    const href = link.getAttribute('href') || '';
    const isDocumentFile = /\.(pdf|doc|docx|zip)(?:[?#]|$)/i.test(href);
    const hasDownloadLabel = /(descargar|ficha tecnica|instructivo|manual(?: de)? instalacion)/.test(label);

    return label !== '' && (link.hasAttribute('download') || isDocumentFile || hasDownloadLabel);
  }

  normalizeText(value) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  removeEmptyWrapper(element) {
    let currentElement = element;

    while (currentElement && !currentElement.classList.contains('accordion__content')) {
      const parentElement = currentElement.parentElement;
      const hasContent = currentElement.textContent.trim() !== '' ||
        currentElement.querySelector('img, video, audio, iframe, object, embed');

      if (hasContent) break;

      currentElement.remove();
      currentElement = parentElement;
    }
  }
}

if (!customElements.get('nl-description-tabs')) {
  customElements.define('nl-description-tabs', NLDescriptionTabs);
}
